import { render, staticRenderFns } from "./DispatchingRules.vue?vue&type=template&id=69a88487&scoped=true"
import script from "./DispatchingRules.vue?vue&type=script&lang=js"
export * from "./DispatchingRules.vue?vue&type=script&lang=js"
import style0 from "./DispatchingRules.vue?vue&type=style&index=0&id=69a88487&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a88487",
  null
  
)

export default component.exports